import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from './lib/cn.js';
import { countryFlag, countryName, countryNameWithCode, formatCountryList, normalizeCountryCode, } from './lib/country.js';
/**
 * Страна словами: флаг, название по-русски, код мелко — «🇩🇪 Германия DE».
 *
 * Код не убран совсем: Meta, Stripe и выгрузки говорят кодами, и оператору,
 * сверяющему экран с ними, нужен именно он. Но читается первым название.
 * Флаг скрыт от скринридера (он дублирует название), полное «Германия (DE)»
 * — в `title`. Неизвестный код — без флага и без повтора: просто `EL`.
 */
export function CountryLabel({ code, showCode = true, showFlag = true, className, }) {
    const name = countryName(code);
    const known = name !== code;
    const iso = normalizeCountryCode(code);
    return (_jsxs("span", { className: cn('inline-flex min-w-0 items-baseline gap-1', className), title: countryNameWithCode(code), "data-country": iso ?? code, children: [showFlag && known ? (_jsx("span", { "aria-hidden": "true", className: "shrink-0", children: countryFlag(code) })) : null, _jsx("span", { className: cn('truncate', !known && 'font-mono'), children: name }), showCode && known ? (_jsx("span", { className: "shrink-0 font-mono text-xs text-[var(--color-text-muted)]", children: iso })) : null] }));
}
CountryLabel.displayName = 'CountryLabel';
/**
 * Список стран строкой для таблиц и сводок: «Германия, Франция и ещё 12»,
 * весь список с кодами — в `title`.
 */
export function CountryListText({ codes, max = 5, emptyLabel = '—', className, }) {
    if (codes.length === 0)
        return _jsx("span", { className: className, children: emptyLabel });
    const { text, full } = formatCountryList(codes, max);
    return (_jsx("span", { className: className, title: full, children: text }));
}
CountryListText.displayName = 'CountryListText';
//# sourceMappingURL=country-label.js.map